module.exports = __webpack_public_path__ + "0b668019a218e8dea7544de6e2e1e94d.png";